import { useState } from 'react';

/**
 * Logo del sito. Di default usa il logo del brand cliente in public/brand/
 * (logo.svg o logo-dark.svg su sfondi scuri, vedi public/brand/README.md);
 * se il file non esiste ancora, o se `settings.useCustomLogo` è attivo,
 * mostra un'immagine personalizzata scelta da admin, con fallback testuale.
 *
 * @param {{
 *   settings?: { useCustomLogo?: boolean, customLogo?: string, logoAlt?: string },
 *   fallbackText: string,
 *   dark?: boolean,
 *   height?: number,
 *   maxWidth?: number,
 *   opacity?: number,
 *   className?: string,
 * }} props
 */
export function BrandLogo({ settings, fallbackText, dark = false, height = 28, maxWidth, opacity = 100, className = '' }) {
  const [failed, setFailed] = useState(false);
  const custom = settings?.useCustomLogo && settings?.customLogo;
  const src = custom || (dark ? '/brand/logo-dark.svg' : '/brand/logo.svg');

  if (failed) {
    return <span className={['font-heading text-lg', className].join(' ')}>{fallbackText}</span>;
  }

  return (
    <img
      src={src}
      alt={settings?.logoAlt || fallbackText}
      style={{ height, width: 'auto', opacity: opacity / 100, ...(maxWidth ? { maxWidth } : {}) }}
      className={className}
      onError={() => setFailed(true)}
    />
  );
}
